import { mainApi } from "services/main";
import { toAuditDateString } from "components/create-audit-form/utils";
import { Audit } from "models/generateAuditSchemas";
import { GaiaObject } from "models/generateGaiaObjSchemas";
import { ProgressUpdateAttachment } from "models/schemas";
import {
  ClosingRequirementResult,
  ClosingRequirementValue,
} from "components/closing-requirements/definitions";

export type UpdateAuditProgressRequest = Audit & {
  progressUpdateAttachments?: ProgressUpdateAttachment[];
  closingRequirementValues?: ClosingRequirementValue[];
};

export interface UpdateAuditProgressResponse {
  audit: Audit;
  closingRequirementWarnings: ClosingRequirementResult[];
}

export interface UpdateGaiaObjectProgressRequest {
  gaiaObjectId: string;
  gaiaObject: GaiaObject;
  progressUpdateAttachments?: ProgressUpdateAttachment[];
  closingRequirementValues?: ClosingRequirementValue[];
}

export interface UpdateGaiaObjectProgressResponse {
  gaiaObject: GaiaObject;
  closingRequirementWarnings?: ClosingRequirementResult[];
}

const extendedApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    updateAuditProgress: builder.mutation<
      UpdateAuditProgressResponse,
      UpdateAuditProgressRequest
    >({
      query: (request) => ({
        url: "audit",
        body: request,
        method: "PUT",
      }),
      transformResponse: (result: {
        audit: Audit;
        closingRequirementWarnings?: ClosingRequirementResult[];
      }) => ({
        audit: toAuditDateString(result.audit),
        closingRequirementWarnings: result.closingRequirementWarnings ?? [],
      }),
      invalidatesTags: ["ActivityLogs"],
    }),
    updateGaiaObjectProgress: builder.mutation<
      UpdateGaiaObjectProgressResponse,
      UpdateGaiaObjectProgressRequest
    >({
      query: (request) => ({
        url: `gaia-objects/${request.gaiaObjectId}`,
        body: request,
        method: "PUT",
      }),
      invalidatesTags: ["ActivityLogs"],
    }),
  }),
  overrideExisting: false,
});

export const {
  useUpdateAuditProgressMutation,
  useUpdateGaiaObjectProgressMutation,
} = extendedApi;
